import SwitchVideo from '../hooks/useVideo'
import mobileVideo from '../assets/videos/mobileDealWhite.mp4'
import desktopVideo from '../assets/videos/desktopDealWhite.mp4'
import poster from '../assets/videos/whiteDealPoster.avif'
import { useTranslation } from 'react-i18next'

export default function DealBannerWhite() {
  const { t } = useTranslation()
  return (
    <section className='flex justify-center py-12 lg:py-24'>
      <div className='w-[92%] lg:w-5/6 flex flex-col md:flex-row gap-8 2xl:gap-16'>
        <div className='w-full xl:w-3/5 2xl:w-3/5'>
          <div className='w-full lg:mb-0'>
            <h2 className='sm:text-4xl text-2xl uppercase sm:mb-2 font-[700]'>
              {t('dealSectionWhite.title')}
            </h2>
            <div className='h-1 w-20 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full'></div>
          </div>
          <h3 className='mt-2 sm:mt-4 text-lg sm:text-xl text-gray-600 drop-shadow-md font-normal '>
            {t('dealSectionWhite.content')}
          </h3>
        </div>
        <div className='hidden xl:block w-2/3 2xl:w-2/5 shadow-md'>
          <SwitchVideo
            mobile={mobileVideo}
            desktop={desktopVideo}
            mobilePoster={poster}
            desktopPoster={poster}
          />
        </div>
      </div>
    </section>
  )
}
